import { lazy } from "react";

import { Loading } from "./simple-loader";
import BackButton from "./back-button";
import ChunkErrorBoundary from "./chunk-error-boundary";

const DocumentUpload = lazy(() => import("./document-upload"));
const ImagePicker = lazy(() => import("./image-picker"));
const ImageGrid = lazy(() => import("./image-grid"));

export { Loading, ImagePicker, DocumentUpload, ImageGrid, BackButton, ChunkErrorBoundary };
